export default function PolicyLink ({ url }) {
    return (
        <div className="mb-4">
            <a 
                className="big-p flex items-center justify-between p-2 rounded bg-slate-700" 
                href={url}
                rel="noreferrer"
                target="_blank"
            >
                Privacy Policy
                <i className="ml-1 fa-solid fa-arrow-up-right-from-square" />
            </a>
        </div>
    )
}